import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { GroupColaboratorUpdate, GroupCollaboratorAlter, GroupCollaboratorDelete, GroupProduct } from 'src/app/models/group';
import { CollaboratorWithoutGroupRequestModel } from 'src/app/models/request/collaborator-without-group';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ColaboratorsGroupService } from 'src/app/services/group/colaborators-group.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { CartaoService } from 'src/app/services/cartao.service';
import { CartaoCadastro } from 'src/app/models/cartao-cadastro';
import { CartaoPeriodoPadrao } from 'src/app/shared/enums/cartao-periodo-padrao.enum';
import { GroupService } from 'src/app/services/group/group.service';
import { ProductsGroupService } from 'src/app/services/group/products-group.service';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import { Departamento } from 'src/app/models/departamento';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Unidade } from 'src/app/models/unidade';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { Group } from 'src/app/models/group';
import { Card } from 'src/app/models/card';
import { AddBatchCards, AddCards } from 'src/app/models/add-cards';
import { CreateCard } from 'src/app/models/create-card';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-grupo-add-collaborator',
  templateUrl: './grupo-add-collaborator.component.html',
  styleUrls: ['./grupo-add-collaborator.component.css']
})
export class GrupoAddCollaboratorComponent implements OnInit {

    private group;
    public currentUser;
    public currentManager;
    public offSet = 0;
    public page = 1;
    public qtdItensPerPage = 10;
    public selectAll = false;
    public totalPages: number;
    public totalRegister: number;
    public deletaColaborador: GroupCollaboratorDelete;
    public colaboradores: { id: number, nome: string, cpf: string, grupo: string, grupoNome:string, selected: boolean }[];
    public colaboradoresSelecionados: { id: number, nome: string, cpf: string, grupo: string, grupoNome:string, selected: boolean }[] = [];
    public ob: CollaboratorFilter = new CollaboratorFilter();
    public filter: ColaboradorFilterOptions = new ColaboradorFilterOptions();
    public countSelectedItens = 0;
    public request: GroupCollaboratorAlter;
    public getGroupRequest: CollaboratorWithoutGroupRequestModel;
    public valorBusca: string;
    public selectedItem;
    public cpfMask: Array<string>;
    public selectedGroup;

    public grupoGuid: string;
    public grupoId: number;
    public grupoNome: string;
    public addColaboradorGrupo: GroupColaboratorUpdate;
    public productsByGroup: Array<GroupProduct>;
    public productFlexGroup: GroupProduct;
    public exibirCadastroFlex = false;
    public collaboradoresDoGrupo: { id: number, nome: string, cpf: string, grupo: string, selected: boolean }[] = [];

    public guidGrupoDoColaborador: string;
    public tipoBeneficio: CategoriaProduto;

    public cartoes: CartaoCadastro[] = [];
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];

    //#region filter form
    public nameCtrl: FormControl = new FormControl();
    public documentCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();
    public departmentCtrl: FormControl = new FormControl();
    public costCenterCtrl: FormControl = new FormControl();
    public unitCtrl: FormControl = new FormControl();
    //#endregion

    //#region filter
    public isMobile = false;
    public exibirFiltro = true;
    public filtroOn: boolean = false;
    public filtroCodigo = '';
    public filtroNome = '';
    public filtroCPF = '';
    public filtroMatricula = '';
    public filtroAplicativo = '';
    public filtroPesquisa = '';
    public filtroUnidade: number[] =[];
    public filtroDepartamento: number[] = [];
    public filtroCentroCusto: number[] = [];
    //#endregion

    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';
    public labelCentroCusto = 'Centro de Custo';
    public labelUnidade = 'Unidade';
    public labelDepartamento = 'Departamento';
    public groups: Array<Group>;
    public totalCola: number = 0;

    public cardFlex: Card = new Card();
    public assignorContractsId: number[] = [];
    referenceValues = [];
    public isFlex: boolean;
    public collaboratorsId = [];
    public cedenteId = 0;
    public cards: Card[] = [];
    public totalCollaborator: number;

    // páginação
    currentPage = 1;
    showItem = '10';
    totalItems = 0;
    collumnName = "name";

    @ViewChild('confirmacao', { static: true })
    confirmacao: TemplateRef<any>;

    constructor(private modalService: NgbModal, private colaboradoresService: ColaboradorService, private collaboratorGroupService: ColaboratorsGroupService,
              private contratoService: ContratoService, private cartaoService: CartaoService,
              private groupService: GroupService, private productsGroupService: ProductsGroupService,
              private colaboradorGroupService: ColaboratorsGroupService, private router: Router,
              private alertService: NewAlertService, private centroCustoService: CentroCustoService,
              private unidadeService: UnidadeService, private departamentoService: DepartamentoService, private parametrosDataService: ParametrosDataService) {
                  this.currentUser = JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser));
                  this.currentManager = JSON.parse(sessionStorage.getItem('gestorCedente'));
                  this.group = JSON.parse(sessionStorage.getItem('Grupo'));

  }

  public sub: Subscription;

    ngOnInit() {
        this.cedenteId = parseInt(sessionStorage.getItem('cedenteId'));
        this.buscarGrupos();
        this.loadViewConfig();
        this.callCollaboradores(1);
        this.callProductsOfGroup(this.group.guidID);
        this.loadFiltroDropDown();
        this.getContracts();
    }

    buscarGrupos() {
    this.groupService.getGroupsByCedente(this.currentUser.token.assignorGuid).subscribe(response => {
        if (response.status === 1) {
               this.groups = response.result;
               this.totalCollaborator = this.groups.find(x => x.guidID == this.group.guidID).countCollaborators;
            }
        });
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.exibirFiltrosColaboradores]) {
                this.exibirFiltro = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFiltrosColaboradores]
                );
            } else {
                this.exibirFiltro = true;
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ]
            ) {
                this.labelCentroCusto = this.parametros[
                    ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ];
            } else {
                this.labelCentroCusto = 'Centro de Custo';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaUnidadeColaborador
                ]
            ) {
                this.labelUnidade = this.parametros[
                    ParametrosKey.labelPersonalizadaUnidadeColaborador
                ];
            } else {
                this.labelUnidade = 'Unidade';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ]
            ) {
                this.labelDepartamento = this.parametros[
                    ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ];
            } else {
                this.labelDepartamento = 'Departamento';
            }
        }
    }

  callCollaboradores(event) {

    this.page = event;
    this.offSet = event - 1;
    this.currentPage = event;
    const offset = this.currentPage - 1;

    this.getGroupRequest = {
        assignorGuid: this.currentUser.token.assignorGuid,
        limit: parseInt(this.showItem),
        page: offset
    };

    const filterOptions = new ColaboradorFilterOptions();

    const filterObject = new CollaboratorFilter();

    filterObject.query = this.filtroPesquisa;
    filterObject.name = this.filtroNome;
    filterObject.document = this.filtroCPF;
    filterObject.register = this.filtroMatricula;

    filterObject.costCenter = this.filtroCentroCusto;
    filterObject.unit = this.filtroUnidade;
    filterObject.departament = this.filtroDepartamento;

    // parametros
    if (this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]) {
        filterOptions.permitirBuscarNome = BooleanConverter.getBoolean(
            this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]
        );
    }
    if (this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]) {
        filterOptions.permitirBuscarCPF = BooleanConverter.getBoolean(
            this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]
        );
    }
    if (
        this.parametros[
        ParametrosKey.permitirBuscaNomeIncrementalColaboradores
        ]
    ) {
        filterOptions.permitirBuscarNomeLike = BooleanConverter.getBoolean(
            this.parametros[
            ParametrosKey.permitirBuscaNomeIncrementalColaboradores
            ]
        );
    }
    if (
        this.parametros[
        ParametrosKey.permitirBuscaCPFIncrementalColaboradores
        ]
    ) {
        filterOptions.permitirBuscarCPFLike = BooleanConverter.getBoolean(
            this.parametros[
            ParametrosKey.permitirBuscaCPFIncrementalColaboradores
            ]
        );
    }
    if (this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]) {
        filterOptions.permitirBuscarVazio = BooleanConverter.getBoolean(
            this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]
        );
    }

    this.colaboradoresService.getCollaboratorsWithoutGroup(this.getGroupRequest, filterObject, filterOptions).subscribe(response => {
        if (response.status === 1) {
            /* console.log(response); */

            this.totalPages = response.result.totalPages;
            this.totalRegister = response.result.totalResults;

            this.colaboradores = response.result.collaborators.map(element => {
                return {
                    nome: element.name,
                    cpf: element.document,
                    id: element.id,
                    grupo: element.grupo.toLowerCase(),
                    grupoNome: "",
                    selected: false
                };
            })/*.filter(x => x.grupo != this.group.guidID )*/;

            for (const s of this.colaboradores) {
                if(s.cpf != null){
                    const tam = environment.TOTAL_CARACTERE_CPF - s.cpf.length;
                    if(s.grupo != ""){
                        s.grupoNome = this.groups.find(e => e.guidID == s.grupo).name
                    };
                    let str = s.cpf.toString();
                    for (let i = 0; i < tam; i++) {
                        str = '0' + str;
                    }
                    s.cpf = str;
                }
            }

            this.colaboradores.forEach(col => {
                // tslint:disable-next-line: triple-equals
                if (col.grupo == this.group.guidID ) {
                    col.selected = true;
                    /*this.selectElementMesmoGrupo(col);
                    if (!this.collaboradoresDoGrupo.find(e => e.cpf === col.cpf)) {
                        this.collaboradoresDoGrupo.push(col);
                    }*/
                }
            });



            this.markedColaboradores();
        } else {
            this.alertService.error(response.message);
        }
    }, error => {
        this.alertService.error('Ocorreu um erro ao atribuir um favorecido a um grupo, tente novamente');
    });


  }

  addCollaborators(request: GroupColaboratorUpdate) {
      /* this.collaboratorGroupService.addColaborators(request).subscribe(response => {
          if (response.status === 1) {
            if (response.result === true) {
            }
        }
    }); */
    this.router.navigate(['portal']);
  }
  // verifica os cartões do usuário
  getCartaoFlex(colaboradorId) {
    this.contratoService.getContracts(this.currentUser.token.assignorGuid).subscribe(
        response => {
            if (response.status === 1) {
                this.cartoes = [];
                if (response.result) {
                    for (const s of response.result) {

                            this.cartaoService.getValid(colaboradorId, s.id, this.currentUser.token.assignorGuid).subscribe(
                                responseCartao => {

                                    if (responseCartao.status === 1) {
                                        const cartaoExistente = new CartaoCadastro(responseCartao.result.valorPadrao, responseCartao.result.cartaoPeriodoPadraoId);
                                        cartaoExistente.cartaoId = responseCartao.result.cartaoId;
                                        cartaoExistente.produtoGuid = s.productEligibility.product.produtoGuid.toLowerCase();
                                        cartaoExistente.descricaoProduto = s.productEligibility.product.descricaoProduto;
                                        cartaoExistente.cedenteContratoId = s.id;
                                        cartaoExistente.ativo = responseCartao.result.ativo;
                                        cartaoExistente.valorPadrao = s.standardValue;

                                        /* console.log(cartaoExistente) */
                                        this.cartoes.push(cartaoExistente);


                                    } else {
                                        const cartaoNovo = new CartaoCadastro(0, CartaoPeriodoPadrao.Mensal);
                                        cartaoNovo.cartaoId = 0;
                                        cartaoNovo.produtoGuid = s.productEligibility.product.produtoGuid.toLowerCase();
                                        cartaoNovo.descricaoProduto = s.productEligibility.product.descricaoProduto;
                                        cartaoNovo.cedenteContratoId = s.id;
                                        cartaoNovo.ativo = false;
                                        cartaoNovo.valorPadrao = s.standardValue;

                                        this.cartoes.push(cartaoNovo);

                                    }


                                }
                            );

                    }
                }
            } else {
                this.alertService.error('Ocorreu um erro ao carregar os incentivos');
            }
        }
    );
  }

  selecionarTodos() {
      this.selectAll = !this.selectAll;
      /*this.colaboradores.forEach(item => item.selected = this.selectAll);

      if (this.selectAll) {
          this.colaboradores.forEach(item => {
            if (!this.colaboradoresSelecionados.find(e => e.cpf === item.cpf) && item.grupo !== this.group.guidID) {
                this.colaboradoresSelecionados.push(item);
                this.collaboratorsId.push(item.id);
            }
          });
      } else {*/
        this.colaboradoresSelecionados = []
        this.collaboratorsId = [];
        this.colaboradores.forEach(element => {
            if(element.grupo != this.group.guidID){
                element.selected = false;
            } else {
                element.selected = !this.selectAll;
            }
        });
      /*}
      */
      this.countSelectedItens = this.selectAll ? this.totalRegister-this.totalCollaborator-this.colaboradoresSelecionados.length : this.colaboradoresSelecionados.length;
  }

  selectElementMesmoGrupo(item) {
    const colaborador = this.colaboradores.find(e => e.id === item.id);
    if (colaborador.selected === true) {
        if (!this.colaboradoresSelecionados.find(e => e.id === colaborador.id)) {
          this.colaboradoresSelecionados.push(colaborador);
        }
    } else {
      this.colaboradoresSelecionados = this.colaboradoresSelecionados.filter(e => e.id !== colaborador.id);
    }

    this.countSelectedItens = this.selectAll ? this.totalRegister-this.totalCollaborator-this.colaboradoresSelecionados.length : this.colaboradoresSelecionados.length;
  }

  selectElement(item) {

      const colaborador = this.colaboradores.find(e => e.id === item.id);
      colaborador.selected = !item.selected;


      const index = this.colaboradoresSelecionados.indexOf(colaborador);

      if (colaborador.selected === true) {
          if (!this.colaboradoresSelecionados.find(e => e.id === colaborador.id)) {
            this.colaboradoresSelecionados.push(colaborador);
            this.collaboratorsId.push(colaborador.id);
          }
      } else {
        this.colaboradoresSelecionados = this.colaboradoresSelecionados.filter(e => e.id !== colaborador.id);
        this.collaboratorsId = this.collaboratorsId.filter(e => e !== colaborador.id);
      }

      this.countSelectedItens = this.selectAll ? this.totalRegister-this.totalCollaborator-this.colaboradoresSelecionados.length : this.colaboradoresSelecionados.length;
  }

  callProductsOfGroup(guidDoGrupo) {
    this.productsGroupService.getGroupsByGroup(guidDoGrupo).subscribe(response => {
        if (response.status === 1) {
            this.productsByGroup = [];
            response.result.forEach(obj => {
               /*if (obj.productCategory !== 2) {*/
                this.productsByGroup.push(obj);
               /*} else {
                this.productFlexGroup = obj;
               }*/
            });


        } else {
          this.alertService.error(response.message);
      }
    }, error => {
      this.alertService.error('Ocorreu um erro ao listar os produtos do grupo, tente novamente');
  });
}
    // adiciona colaborador ao grupo e atualiza/ cria os cartões
  getGrupoColaboradores(colaboradorId) {
      //console.log(true);
    this.colaboradorGroupService.getGrupoColaborador(this.currentUser.token.assignorGuid, colaboradorId).subscribe(response => {

        if (response.status === 1) {

            this.deletaColaborador = new GroupCollaboratorDelete();
            this.deletaColaborador.collaboratorIDs = [];
            this.deletaColaborador.collaboratorIDs.push(colaboradorId);
            this.deletaColaborador.groupGuid = response.result;

            if (response.result !== '00000000-0000-0000-0000-000000000000') {

                this.colaboradorGroupService.removeCollaborator(this.deletaColaborador).subscribe(resDelete => {


                    if (resDelete.status === 1) {

                        this.addColaboradorGrupoFlex(colaboradorId);
                    }
                });
            } else {

                this.addColaboradorGrupoFlex(colaboradorId);
            }


        } else {


            this.addColaboradorGrupoFlex(colaboradorId);
        }
    });
  }

  addColaboradorGrupoFlex(colaboradorId) {
      /* console.log(colaboradorId) */
      this.addColaboradorGrupo = new GroupColaboratorUpdate();
      this.addColaboradorGrupo.collaboratorIDs = [];
      this.addColaboradorGrupo.collaboratorIDs[0] = colaboradorId;
      this.addColaboradorGrupo.groupGuid = this.group.guidID;
      this.colaboradorGroupService.addColaborators(this.addColaboradorGrupo).subscribe(resAdd => {
        if (resAdd.status === 1) {
            // tslint:disable-next-line: prefer-const
            let cartaoAtualiza: CartaoCadastro[] = [];
            // tslint:disable-next-line: prefer-const
            let cartaoInativa: CartaoCadastro[] = [];
            // tslint:disable-next-line: prefer-const
            let cartaoCria: CartaoCadastro[] = [];


                // if(obj.productName)




            for (const obj2 of this.cartoes){
                obj2.ativo = false;
                for (const obj of this.productsByGroup){
                    // Verifica se os produtos são o produto é o mesmo
                    // tslint:disable-next-line: triple-equals
                    if (obj.productGuid == obj2.produtoGuid) {

                        obj2.ativo = true;
                        obj2.valorPadrao = obj.value;
                        obj2.cartaoPeriodoPadrao = obj.standardPeriodCard;
                        if (obj2.valorPadrao < 0) {
                            // erro = true;
                        } else {
                            // verifica se já possui cartão
                            // tslint:disable-next-line: triple-equals
                            if (obj2.cartaoId == 0) {
                                obj2.ativo = true;
                                cartaoCria.push(obj2);

                            } else {
                                cartaoAtualiza.push(obj2);

                            }
                        }
                    } else {

                        // inativa o cartão
                        if (obj2.cartaoId >= 0) {

                            this.cartaoService.update(obj2.cartaoId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                                response => {

                                    if (response.status !== 1) {
                                        // erro = true;
                                    }
                                }
                            );
                        }
                    }

                };

             }
            cartaoAtualiza.forEach(obj2 => {
                this.cartaoService.update(obj2.cartaoId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                    response => {
                        if (response.status !== 1) {
                            // erro = true;
                        }
                    }
                );
             });
            cartaoCria.forEach(obj2 => {
                this.cartaoService.add(colaboradorId, obj2.cedenteContratoId, this.currentUser.token.assignorGuid, obj2).toPromise().then(
                    response => {

                        if (response.status !== 1) {
                            // erro = true;
                        }
                    }
                );
             });

        }
    });
}

  removerColaborador() {
    this.collaboradoresDoGrupo.forEach(col => {
        if (col.selected === false) {
            const deletaColaboradores = new GroupCollaboratorDelete();
            deletaColaboradores.collaboratorIDs = [];
            deletaColaboradores.collaboratorIDs.push(col.id);
            deletaColaboradores.groupGuid = col.grupo;
            this.colaboradorGroupService.removeCollaborator(deletaColaboradores).subscribe(res => {
            });
        }
    });

    this.router.navigate(['portal/grupos/detalhe']);

  }
    finalizar() {
        /*const collaboratorsAdicionar = [];
        const collaboradorTrocar = [];

        this.colaboradoresSelecionados.forEach(ben => {
            // tslint:disable-next-line: triple-equals
            if (ben.grupo == this.group.guidID) {

            // tslint:disable-next-line: triple-equals
            } else if (ben.grupo == '') {
                collaboratorsAdicionar.push(ben);
                this.getCartaoFlex(ben.id);
                this.getGrupoColaboradores(ben.id);
            } else {
                collaboradorTrocar.push(ben);
                this.getCartaoFlex(ben.id);
                this.getGrupoColaboradores(ben.id);

            }
        });

        this.removerColaborador();
        */
        let addCards = new AddCards();
        addCards.assignorGuid = this.currentUser.token.assignorGuid;
        addCards.managerGuid = this.currentManager.gestorGuid;
        addCards.assignorContractsId = this.assignorContractsId;
        addCards.groupGuid = this.group.guidID;
        addCards.productCategoryWallet = 2;

        let createCards: CreateCard[] = [];

        this.isFlex = true;

        // console.log(this.productFlexGroup)

        const createCard = new CreateCard();
            createCard.assignorContractId = this.cardFlex.assignorContractId;
            createCard.assignorContractsId = this.assignorContractsId;
            createCard.cardId = this.cardFlex.cardId;
            createCard.referenceValue = this.cardFlex.referenceValue;
            createCard.regularityId = parseInt(this.cardFlex.regularityId.toString());
            createCard.productGuid = this.cardFlex.productGuid;
            createCard.productCategory = this.cardFlex.productCategory;
            createCard.active = this.cardFlex.active;
            createCards.push(createCard);

        addCards.createCards = createCards;

        // console.log(this.collaboratorsId);

        let addBatchCards = new AddBatchCards();
        addBatchCards.AddCards = addCards;
        addBatchCards.collaboratorsId = this.collaboratorsId;
        addBatchCards.selectAll = this.selectAll;

        this.cartaoService.newAddBatch(addBatchCards,this.isFlex).subscribe(
            response => {
                if(response.status == ApiError.Sucesso){
                    this.modalService.open(this.confirmacao,{ centered: true, size: 'lg' })

                    this.status(response.result)
                    this.alertService.success("Sucesso!");
                    this.isFlex = false;
                    this.getContracts();
                    this.buscarGrupos();
                }
                else{
                    this.alertService.error(response.message);
                    this.isFlex = false;
                }
            }, error => {console.log(error)}
        )
        this.router.navigate(['portal/grupos/detalhe']);
    }
    
    status(id: any){
        const options = {
            autoClose: false,
            keepAfterRouteChange: true
        };

        this.sub = timer(0, 10000).pipe(
            map(() => {              
                this.cartaoService.statusBatch(id,this.currentUser.token.assignorGuid)
                .subscribe(
                    response => {
                        if(response.status == ApiError.Sucesso){
                            if(response.result.total == (response.result.processada + response.result.erro)) {
                                
                                this.alertService.notificationSuccess(
                                    "Atualização de grupo", 
                                    "A atualização do grupo foi concluída",
                                    options
                                );

                                this.sub.unsubscribe();
                            }
                        }
                        else{
                            this.sub.unsubscribe();
                            //this.alertService.error(response.message);
                        }
                    }, error => {console.log(error)}
                ) // load data contains the http request
            })
          ).subscribe();
    }

    onSumit(content){
        if (this.countSelectedItens === 0) {
            this.alertService.error('É preciso selecionar pelo menos um favorecido!');
            return;
        }
        this.atualizaModal(content);
        if(this.totalCola>0 && !this.selectAll){
            this.modalService.open(content, { centered: true, size: 'lg' });
        } else {
            this.finalizar();
        }
    }

    getContracts(){
        this.contratoService.getContracts(this.currentUser.token.assignorGuid, this.tipoBeneficio).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result) {

                        this.referenceValues = [];
                        this.assignorContractsId = [];
                        for (const s of response.result) {
                            this.assignorContractsId.push(s.id);
                            this.referenceValues.push({valorPadrao: s.standardValue,cedenteContratoId: s.id});
                        }
                        this.cartaoService.getValidCardBatch(0, this.currentUser.token.assignorGuid, this.assignorContractsId).subscribe(
                            responseB => {
                                if(response.status == ApiError.Sucesso){
                                    this.cards = responseB.result.sort((a, b) => a.productDescription.localeCompare(b.productDescription));
                                    this.cards.forEach(element => {
                                        if(element.referenceValue == 0 && this.grupoId == 0 && this.tipoBeneficio == CategoriaProduto.Tradicional){
                                            element.referenceValue = this.referenceValues.find(x=>x.cedenteContratoId == element.assignorContractId).valorPadrao;
                                        }
                                    });
                                    this.cardFlex = this.cards.find(e => e.productCategory == 2);
                                }
                            }
                        );
                    }
                } else {
                    this.alertService.error('Ocorreu um erro ao carregar os incentivos');
                }
            }
        );
    }

    atualizaModal(content){
        this.totalCola=0;
        this.groups.forEach(g => {
            this.totalCola = this.totalCola + this.colaboradoresSelecionados.filter(e => e.grupo == g.guidID ).length;
        });
        if(this.totalCola<=0){
            this.modalService.dismissAll();
        }
    }

  changePage(event) {
      this.page = event;
      const offset = this.page - 1;
      this.callCollaboradores(offset);
      this.selectAll = false;
  }

  markedColaboradores() {
      this.colaboradores.forEach(element => {
          if (this.colaboradoresSelecionados.find(e => e.id === element.id)) {
              element.selected = true;
          }
      });
  }

  public loadFiltroDropDown() {
    this.centroCustoService
        .getAll(this.currentUser.token.assignorGuid)
        .subscribe(response => {
            this.centrosCustosList = response.result;
            /* this.centrosCustosList.forEach(obj => {
                this.filtroCentroCustoDropDownList.push(
                    new DropDownItem(obj.centroCustoId.toString(), obj.nome)
                );
            }); */
        });

    this.unidadeService
        .getAll(this.currentUser.token.assignorGuid)
        .subscribe(response => {
            this.unidadesList = response.result;
            /* this.unidadesList.forEach(obj => {
                this.filtroUnidadeDropDownList.push(
                    new DropDownItem(obj.unidadeId.toString(), obj.nome)
                );
            }); */
        });

    this.departamentoService
        .getAll(this.currentUser.token.assignorGuid)
        .subscribe(response => {
            this.departamentosList = response.result;
            /* this.departamentosList.forEach(obj => {
                this.filtroDepartamentoDropDownList.push(
                    new DropDownItem(
                        obj.departamentoId.toString(),
                        obj.nome
                    )
                );
            }); */
        });

        /* this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        }; */
    }

    showItemChanged(event) {
        this.showItem = event;
        this.callCollaboradores(1);
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    applyFilter() {

        this.filtroNome = this.nameCtrl.value;
        this.filtroCPF = this.documentCtrl.value;
        this.filtroMatricula = this.registerCtrl.value;
        this.filtroCentroCusto = this.costCenterCtrl.value;
        this.filtroDepartamento = this.departmentCtrl.value;
        this.filtroUnidade = this.unitCtrl.value;

        if(
            this.filtroNome == null &&
            this.filtroCPF == null &&
            this.filtroMatricula == null &&
            this.filtroCentroCusto == null &&
            this.filtroDepartamento == null &&
            this.filtroUnidade == null
        ){
            this.filtroOn = false;
        } else {
            this.filtroOn = true;
            this.callCollaboradores(1)
            this.modalService.dismissAll();
        }

    }

    deleteFilter(){
        this.filtroNome = "";
        this.filtroCPF = "";
        this.filtroMatricula = "";
        this.filtroCentroCusto = [];
        this.filtroUnidade = [];
        this.filtroDepartamento = [];
        this.filtroOn = false;

        this.callCollaboradores(1);
    }

}
